import { useMemo } from 'react';
import useFriendApplications from '@/hooks/users/use-friend-applications';
import { useFriendRequestCountStore } from '@/stores/friend-request-count';

export default function useFriendRequestCount() {
  const { data } = useFriendApplications();

  const { friendRequestIds, updateFriendRequestId } = useFriendRequestCountStore();

  const friendRequestCount = useMemo(
    () => data?.applications.filter(({ id }) => !friendRequestIds.includes(id)).length ?? 0,
    [data?.applications, friendRequestIds],
  );

  const markAllAsRead = () => {
    const applicationIds = data?.applications.map((app) => app.id) ?? [];
    updateFriendRequestId(applicationIds);
  };

  const clearFriendRequestId = (id: number) => {
    updateFriendRequestId(friendRequestIds.filter((rId: number) => rId !== id));
  };

  return {
    friendRequestCount,
    markAllAsRead,
    clearFriendRequestId,
  };
}
